export const environment = {
  production: true,
  logLevel: 3,
  enableLogging: false,
  name: 'production',
  tokenRenewalTestIntervalSeconds: undefined,
  cognitoUrl: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_nmBceZJau',
  cognitoDomain: 'https://mmscan-sso.auth.ca-central-1.amazoncognito.com',
  cognitoClientId: 'j32kvf5o8tgq6mm2969k7lagp',
  url: 'https://miportal.mitsubishi-motors-canada.com',
  api: 'https://miportal.mitsubishi-motors-canada.com',
  mmscanApiUrl: 'https://api.mitsubishi-motors-canada.com',
};
